// Vue plugins
import Vue from 'vue'
import VModal from 'vue-js-modal'
import VueWait from 'vue-wait'
import VueSimpleSpinner from 'vue-simple-spinner'

// Import vuedraggable before vue-toasted because both polyfill String.prototype.includes and if the
// polyfill of vue-toasted is applied first then the polyfill of vuedraggable cannot be applied and
// the page crashes. The other way around works.
import 'vuedraggable'
import Toasted from 'vue-toasted'

import {
  AlertPlugin,
  ButtonPlugin,
  CarouselPlugin,
  FormCheckboxPlugin,
  FormDatepickerPlugin,
  ImagePlugin,
  InputGroupPlugin,
  ModalPlugin,
  NavbarPlugin,
  OverlayPlugin,
  PaginationPlugin,
  PopoverPlugin,
  TablePlugin,
  TooltipPlugin,
} from 'bootstrap-vue'
import VueScrollTo from 'vue-scrollto'
import Vuelidate from 'vuelidate'

Vue.use(AlertPlugin)
Vue.use(ButtonPlugin)
Vue.use(CarouselPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(ImagePlugin)
Vue.use(InputGroupPlugin)
Vue.use(ModalPlugin)
Vue.use(NavbarPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)
Vue.use(PopoverPlugin)
Vue.use(VueScrollTo)
Vue.use(TablePlugin)
Vue.use(Toasted)
Vue.use(TooltipPlugin)
Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true })
Vue.use(Vuelidate)
Vue.use(VueWait)

Vue.component('vue-simple-spinner', VueSimpleSpinner)
